import { render, staticRenderFns } from "./FieldGroup.vue?vue&type=template&id=19af01b2&scoped=true"
import script from "./FieldGroup.vue?vue&type=script&lang=js"
export * from "./FieldGroup.vue?vue&type=script&lang=js"
import style0 from "./FieldGroup.vue?vue&type=style&index=0&id=19af01b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19af01b2",
  null
  
)

export default component.exports